/// <amd-module name="SuiteCommerce.Blog.DataProvider.Author.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.DataProvider.Author.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AuthorModel = /** @class */ (function (_super) {
        __extends(AuthorModel, _super);
        function AuthorModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(AuthorModel.prototype, "id", {
            get: function () {
                return this.get('id');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthorModel.prototype, "name", {
            get: function () {
                return this.get('name');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AuthorModel.prototype, "urlComponent", {
            get: function () {
                return this.get('urlComponent');
            },
            enumerable: true,
            configurable: true
        });
        return AuthorModel;
    }(Backbone_1.Model));
    exports.AuthorModel = AuthorModel;
});
